import React from 'react';
import { Field, isDirty, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { askConfirmAction } from 'actions/confirm-action';
import {
  onClickCreateCategory,
  setListCategories,
  categoriesRequest,
} from 'actions/businessLibrary/category';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import { ActionBarWrapper } from 'components/wrappers/pages';
import MenuTitle from 'components/MenuTitle';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';

import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    return (
      <div>
        <MenuTitle menuTitle="Categories" />
        <div className="col-sm-4 hidden-xs col-md-6 action-categories">
          <span className="pull-right">
            <button
              className="btn btn-primary"
              onClick={this._onClickCreateCategory}
            >
              Create Category
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className="row">
            <div className={`col-sm-12 col-xs-12 col-md-8 ${styles.wrapper}`}>
              <Field
                name="keyword"
                component={SearchBar}
                onChange={this._onChangeKeyword}
                placeholder="Search"
              />
            </div>
          </div>
        </ActionBarWrapper>
      </div>
    );
  }

  _onClickCreateCategory = () => {
    const { isDirtyCategory, dispatch } = this.props;
    if (isDirtyCategory) {
      dispatch(askConfirmAction(onClickCreateCategory()));
    } else {
      dispatch(onClickCreateCategory());
    }
  };

  _onChangeKeyword = (_, keyword) => {
    const { dispatch } = this.props;
    dispatch(setListCategories([]));
    dispatch(showPageLoadingSpinner(true));
    dispatch(categoriesRequest({ keyword, with_uncategorized: false }));
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const isDirtyCategory = isDirty('categoryHub')(state);
  return {
    isDirtyCategory,
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(ActionBar));
